import { render } from "./NewButton.vue?vue&type=template&id=6e885ac3"
const script = {}

import "./NewButton.vue?vue&type=style&index=0&id=6e885ac3&lang=css"

import exportComponent from "/home/forge/fortiuspro.onlinesolutionsltd.com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__